import debounce from 'just-debounce-it';
const backToTopLink = document.querySelector('.back-to-top');
const scrollTrigger = 600;
function backToTop() {
    if (window.scrollY > scrollTrigger) {
        backToTopLink.ariaHidden = 'false';
        backToTopLink.tabIndex = 0;
    }
    else {
        backToTopLink.ariaHidden = 'true';
        backToTopLink.tabIndex = -1;
    }
}
backToTop();
if (backToTopLink) {
    window.addEventListener('scroll', debounce(backToTop, 500));
}
